"use client";

/** Список всех новостей с подгрузкой по кнопке «Показать ещё» (как в каталоге). */

import { useState } from "react";
import NewsCard from "./NewsCard";
import type { NewsItem } from "@/lib/fleet-server";
import { useLocale } from "@/lib/locale-context";

const PAGE = 9;

export default function NewsListClient({ items }: { items: NewsItem[] }) {
  const { t } = useLocale();
  const [visible, setVisible] = useState(PAGE);
  if (!items.length) {
    return <div className="py-16 text-center text-[16px] text-text-muted">{t("news.empty")}</div>;
  }
  const shown = items.slice(0, visible);
  return (
    <div>
      <div className="grid grid-cols-1 items-stretch gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {shown.map((n) => (
          <NewsCard key={n.slug} item={n} />
        ))}
      </div>
      {visible < items.length && (
        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((v) => v + PAGE)}
            className="cursor-pointer rounded-xl bg-primary px-24 py-4 text-[16px] font-bold text-white transition hover:bg-primary-hover"
          >
            {t("news.showMore")}
          </button>
        </div>
      )}
    </div>
  );
}
